/**
 * WorkOS AuthKit session persistence:
 * - With a custom Authentication API domain → HTTP-only cookies (devMode off).
 * - Without one → refresh token in localStorage so the same device stays signed in.
 *
 * @see https://workos.com/docs/authkit/client-only
 */
export interface WorkOSAuthKitEnv {
    apiHostname?: string;
    devModeOverride?: string;
}

export function getWorkOSAuthKitConfig(
    env: WorkOSAuthKitEnv = {
        apiHostname: import.meta.env.NEXT_PUBLIC_WORKOS_AUTH_API_HOSTNAME,
        devModeOverride: import.meta.env.NEXT_PUBLIC_WORKOS_DEV_MODE,
    },
) {
    const apiHostname = env.apiHostname?.trim() || undefined;
    const devModeOverride = env.devModeOverride?.trim().toLowerCase();

    const devMode =
        devModeOverride === "true"
            ? true
            : devModeOverride === "false"
              ? false
              : !apiHostname;

    return { apiHostname, devMode };
}
